export default {
  data() {
    return {
      badgeStatus: {
        'pending_approval': 'warning',
        'suspended': 'danger',
        'active': 'primary',
      },
      badgeText: {
        'pending_approval': '審査中',
        'suspended': '却下済み',
        'active': '承認済み',
      }
    }
  },
};
